import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import { history } from '../helpers';

import { PageActions, ImageBox, Section, TextArea, TextInput, SwitchInput, ImageInput, EditorInput } from '../components';
import DatePicker from 'react-datepicker';
import { userActions, generalActions } from '../actions';
import { generalService } from '../services';


class ClientDetailPage extends React.Component {
  constructor(props) {
      super(props);

      this.pid = 401 ; //home page
      if(this.props.match.params.id != undefined){
        this.props.dispatch(generalActions.getContent(this.props.match.params.id,this.pid));  
      }else{
        this.props.dispatch(generalActions.getContent(0,0));  
      }

      this.state = {
        id: null,
        payload:{
          logo: '',
          name: ''
        },
        isLoaded :false,
        isEdit:false
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);

  }

  componentWillReceiveProps(props){

      const { content, upload } = props;
      const { data, id } = content;
      const { payload } = this.state;

      if(data && !this.state.isEdit){
        let dataPayload = {
          logo: data.logo,
          name: data.name
        }

        this.setState({ payload:dataPayload, id:id, isLoaded:true, isEdit:true });

      }else{

        if(!upload.uploaded){
          setTimeout(()=>this.setState({ isLoaded: true}),1000);  
        }

      }


      if(upload.uploaded){
        console.log("payload : ", payload);
        this.setState({payload:{...payload, logo:upload.data}});
      }
  }

  getCity(){
    this.props.dispatch(generalActions.getContent(0,501)); 
  }

  getlogo(){
    this.setState({dataGet:'logo'});
    this.props.dispatch(generalActions.getContent(this.props.match.params.id,507)); 
  }

  handleChange(e) { 
    const { name, value } = e.target;
    const { payload } = this.state;

    this.setState({payload:{...payload, [name]:value}});
  }

  handleFileChange(e) {
      const { name, value } = e.target;

      const file = e.target.files[0];
      const formData = new FormData();

      if(file){
        formData.set('file', file, file.name);
        
        if (formData) {
          this.props.dispatch(generalActions.postUpload(formData));
        }

      }
  }

  handleSubmit(e) {
    e.preventDefault();
    const { dispatch, content } = this.props;
    const { id } = this.state;
    const payload = this.state.payload;

    this.setState({ submitted: true });

    if(id){
      dispatch(generalActions.postContent(payload, id, this.pid));  
    }else{
      dispatch(generalActions.putContent(payload, this.pid));  
    }
  }

  handleDelete(e) {
    e.preventDefault();
    const { dispatch, content } = this.props;
    const { id } = this.state;

    if(id){
      dispatch(generalActions.deleteContent(id)); 
      setTimeout(()=>history.push('/clients'),1000); 
    }
  }

  render() {
    const {payload} = this.state;
    return (
      <div className={this.state.isLoaded ? "content-wrapper" : "content-wrapper loader-light"}>
      {
        this.state.isLoaded ?
        <form role="form" name="contact" className="needs-validation" noValidate="true">
          <section className="content-header clearfix">
            <h1 className="content-header-title">
              Client
            </h1>
            <div className="btn-placeholder">
              <button type="submit" className="btn btn-primary" onClick={this.handleSubmit}>
                <span className="visible-xs"><i className="fa fa-check"></i>&nbsp;</span>
                <span className="hidden-xs">Save</span>
              </button>
              <button type="submit" className="btn btn-primary" onClick={this.handleDelete}>
                <span className="visible-xs"><i className="fa fa-trash"></i>&nbsp;</span>
                <span className="hidden-xs">Delete</span>
              </button>
            </div>
          </section>
            <section className="content">
              <Section section_title="Client" section_description=''>
                <div className="form-group">
                  <ImageInput
                    input_label="Logo"
                    input_name="logo"
                    input_helper="Recommended dimensions of 1480 × 557 px. Save with 50 quality in .jpg format to reduce file size."
                    input_onChange={this.handleFileChange}
                    input_value={this.state.payload.logo}
                  />
                </div>
                <TextInput
                    input_label="Client Name"
                    input_placeholder="Enter Client Name"
                    input_name="name"
                    input_type="text"
                    input_is_required={true}
                    input_onChange={this.handleChange}
                    input_value={this.state.payload.name}
                  />
              </Section>
            </section>
          </form>
          :
        <div className="loader"></div>
      }
      </div>
    );
  }
}

function mapStateToProps(state) {
    const { authentication, general } = state;
    const { content, upload } = general;
    return {
        content,
        upload
    };
}

const connectedClientDetailPage = connect(mapStateToProps)(ClientDetailPage);
export { connectedClientDetailPage as ClientDetailPage };


// WEBPACK FOOTER //
// ./src/pages/ClientDetailPage.js